import { CaretRightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Collapse, message, Modal, Switch } from "antd";
import React, { useEffect, useState } from "react";
import Table from "../Common/Table/Table";
import usePayAxios from "../../config/useAxios";
import deleteIcon from "../../assets/icons/delete.png";
import moment from "moment";

const CardsSaved = ({ cardData }) => {
  const { Panel } = Collapse;
  const { onCall: getCardTokens, data: cardTokensData } = usePayAxios({
    api: "/api/cards/v1/getCardTokens",
    method: "get",
  });
  const {
    onCall: actionCardTokens,
    data: AcionCardTokensData,
    reset: actionCardTokensReset,
  } = usePayAxios({
    api: "/api/admin/cards/v1/lcm-on-card-tokens",
    method: "post",
  });
  const [isDelete, setIsDelete] = useState(false);
  const columns = [
    {
      title: "Merchant Name",
      dataIndex: "merchantName",
      key: "merchantName",
    },
    {
      title: "Request ID",
      dataIndex: "tokenRequestorId",
      key: "tokenRequestorId",
    },
    {
      title: "Status",
      dataIndex: "tokenState",
      key: "tokenState",
    },
    {
      title: "Enable",
      dataIndex: "tokenState",
      key: "tokenState",
      render: (text, record) => (
        <div>
          <Switch
            className="switch"
            defaultChecked={text === "ACTIVE"}
            onChange={(checked) => {
              if (cardData?.id && record?.tokenReferenceId) {
                actionCardTokens({
                  data: {
                    card_id: cardData.id,
                    token_reference_id: record.tokenReferenceId,
                    lcm_action: checked ? "RESUME_TOKEN" : "SUSPEND_TOKEN",
                    request_reason: "",
                  },
                });
              } else {
                console.warn("cardData or tokenReferenceId is undefined");
              }
            }}
            checked={text === "ACTIVE"}
          />
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "tokenCreationDateTime",
      key: "tokenCreationDateTime",
      render: (text) => (
        <div>{moment(text, "YYYYMMDDHHmmss").format("DD MMM YYYY")}</div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <div
          onClick={() => {
            setIsDelete(record);
          }}
        >
          <img src={deleteIcon} alt="delete icon" width={25} />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (cardData?.id)
      getCardTokens({
        params: {
          card_id: cardData?.id,
        },
      });
  }, [cardData?.id]);

  useEffect(() => {
    if (AcionCardTokensData?.status == true) {
      setIsDelete(false);
      getCardTokens({
        params: {
          card_id: cardData?.id,
        },
      });
      actionCardTokensReset();
    } else if (AcionCardTokensData?.status == false) {
      actionCardTokensReset();
    }
  }, [AcionCardTokensData]);

  const handleDelete = () => {
    actionCardTokens({
      data: {
        card_id: cardData?.id,
        token_reference_id: isDelete?.tokenReferenceId,
        lcm_action: "UNLINK_TOKEN",
        request_reason: "",
      },
    });
  };
  return (
    <>
      <Modal
        title="Delete User"
        open={isDelete}
        onCancel={() => {
          setIsDelete(false);
        }}
        footer={[]}
        className="center-aligned-modal"
      >
        Are you sure you want to delete?
        <div className="d-flex">
          <Button
            key="1"
            htmlType="submit"
            className="formButton mt1"
            onClick={handleDelete}
          >
            Confirm
          </Button>
          <Button
            key="2"
            className="cancelButton ml1 mt1"
            onClick={() => {
              setIsDelete(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <div className="p1 pr0">
        <Collapse
          bordered={false}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          expandIconPosition={"right"}
          className="site-collapse-custom-collapse"
        >
          <Panel header={"Card Tokens"} key="1" className="accordion-heading">
            <div className="flex-col">
              <Table
                rowKey="id"
                className="tableStyled table-befor-style"
                columns={columns}
                data={cardTokensData?.response?.tokenList}
                isMore={false}
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default CardsSaved;
